var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23V24H26V26H6V6H8V21C11 21 14 19 16.1 15.4C19.1 10.4 22.4 8 26 8V10C23.2 10 20.5 12.1 17.9 16.5C15.3 20.6 11.7 23 8 23Z",
    fill: "#DB1C29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.9d08430a8c6974100fd59deec5fbc280.svg";
export { ForwardRef as ReactComponent };